import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { SearchOutlined } from '@ant-design/icons';

const { Search } = Input;

const SearchAddress = styled(Search)`
  &&& {
    border-radius: 12px;
    padding: 0 45px;
    height: 44px;
    background: white;
    .ant-input-suffix {
      display: none;
    }
    .ant-input {
      background: white;
      font-size: 13px;
    }
  }
`;
const Wrapper = styled.div`
  &&& {
    position: relative;
    .anticon-search {
      position: absolute;
      z-index: 1;
      font-size: 18px;
      top: 14px;
      left: 10px;
    }
  }
`;

function SeacrhDevice({
  search,
  generalTotal,
  total,
  limit,
  setStateSearch,
  filter,
  select,
}) {
  const { t } = useTranslation();
  const handleSearch = (value) => {
    setStateSearch(value.toLowerCase().trim().replace(/\s/g, ''));
    search({
      serial: value.toLowerCase().trim().replace(/\s/g, ''),
      warehouse_id: select !== null && select !== '' ? select : null,
      outdated: filter ? (filter.oldVersion ? 1 : null) : null,
      synchronized: filter ? (filter.errorSync ? 0 : null) : null,
      box_id__is_null: filter
        ? [filter.notAtt ? 1 : null, filter.att ? 0 : null]
        : null,
      online: filter
        ? [filter.online ? 1 : null, filter.offline ? 0 : null]
        : null,
      limit,
    });
  };
  const onChange = (e) => {
    if (e.target.value === '' && total < generalTotal) {
      setStateSearch(false);
      search({
        limit,
        warehouse_id: select !== null && select !== '' ? select : null,
        outdated: filter ? (filter.oldVersion ? 1 : null) : null,
        synchronized: filter ? (filter.errorSync ? 0 : null) : null,
        box_id__is_null: filter
          ? [filter.notAtt ? 1 : null, filter.att ? 0 : null]
          : null,
        online: filter
          ? [filter.online ? 1 : null, filter.offline ? 0 : null]
          : null,
      });
    }
  };
  return (
    <>
      <Wrapper>
        <SearchOutlined />
        <SearchAddress
          onChange={onChange}
          onSearch={handleSearch}
          className="rounded-md"
          placeholder={t('searchByMacAddress')}
        />
      </Wrapper>
    </>
  );
}

SeacrhDevice.propTypes = {};

export default SeacrhDevice;
